@if (product) {
  @if (!isMobileView) {
    <div class="container-margin">
      <div class="ingredient-container">
        <div class="product-info-container">
          <div class="img-holder">
            <app-product-image
              loading="eager"
              [picture]="product.picture"
              [name]="product.name"
            />
          </div>
          <div class="highlights-section">
            <app-sustainability-highlights
              [productHighlights]="productHighlights"
            >
            </app-sustainability-highlights>
          </div>
        </div>
        <div class="table-container">
          <div class="row">
            <span class="bold xx-large-font">{{
              translationService.getIngredientsText()
            }}</span>
          </div>
          @if (product.productIngredients.length) {
            <table
              mat-table
              [dataSource]="ingredientsDataSource"
              class="mat-elevation-z0 margin-top-40"
            >
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>
                  {{ translationService.getNameText() }}
                </th>
                <td mat-cell *matCellDef="let ingredient">
                  <div class="icon-text">
                    <span>{{ ingredient.name }}</span>
                    @if (ingredient.optionallyDisclosed) {
                      <mat-icon
                        [matTooltip]="
                          translationService.getOptionalDisclosureText()
                        "
                        >info</mat-icon
                      >
                    }
                    @if (ingredient.isSubstanceOfConcern) {
                      <mat-icon
                        [matTooltip]="
                          translationService.getIngredientIsSubstanceOfConcernText()
                        "
                        >warning</mat-icon
                      >
                    }
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="casNumbers">
                <th mat-header-cell *matHeaderCellDef>
                  {{ translationService.getCasNumbersText() }}
                </th>
                <td mat-cell *matCellDef="let ingredient">
                  {{ ingredient.casNumbers }}
                </td>
              </ng-container>
              <ng-container matColumnDef="concentrationRange">
                <th mat-header-cell *matHeaderCellDef>
                  {{ translationService.getConcentrationRangeText() }}
                </th>
                <td mat-cell *matCellDef="let ingredient">
                  {{ ingredient.lowerConcentration }}% -
                  {{ ingredient.upperConcentration }}%
                </td>
              </ng-container>
              <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns"
                class="header-row"
              ></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          }

          @if (product.mayContain.length) {
            <div class="row margin-top-40">
              <span class="bold large-font">{{
                translationService.getMayContainText()
              }}</span>
            </div>

            <table
              mat-table
              [dataSource]="mayContainDataSource"
              class="mat-elevation-z0 margin-top-40"
            >
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>
                  {{ translationService.getNameText() }}
                </th>
                <td mat-cell *matCellDef="let ingredient">
                  <div class="icon-text">
                    <span>{{ ingredient.name }}</span>
                    @if (ingredient.optionallyDisclosed) {
                      <mat-icon
                        [matTooltip]="
                          translationService.getOptionalDisclosureText()
                        "
                        >info</mat-icon
                      >
                    }
                    @if (ingredient.isSubstanceOfConcern) {
                      <mat-icon
                        [matTooltip]="
                          translationService.getIngredientIsSubstanceOfConcernText()
                        "
                        >warning</mat-icon
                      >
                    }
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="casNumbers">
                <th mat-header-cell *matHeaderCellDef>
                  {{ translationService.getCasNumbersText() }}
                </th>
                <td mat-cell *matCellDef="let ingredient">
                  {{ ingredient.casNumbers }}
                </td>
              </ng-container>
              <tr
                mat-header-row
                *matHeaderRowDef="mayContainDisplayedColumns"
                class="header-row"
              ></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: mayContainDisplayedColumns"
              ></tr>
            </table>
          }

          @if (product.doesNotContain.length) {
            <div class="row margin-top-40">
              <span class="bold large-font">{{
                translationService.getDoesNotContainText()
              }}</span>
            </div>

            <table
              mat-table
              [dataSource]="doesNotContainSource"
              class="mat-elevation-z0 margin-top-40"
            >
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>
                  {{ translationService.getNameText() }}
                </th>
                <td mat-cell *matCellDef="let ingredient">
                  <div class="icon-text">
                    <span>{{ ingredient.name }}</span>
                    @if (ingredient.optionallyDisclosed) {
                      <mat-icon
                        [matTooltip]="
                          translationService.getOptionalDisclosureText()
                        "
                        >info</mat-icon
                      >
                    }
                    @if (ingredient.isSubstanceOfConcern) {
                      <mat-icon
                        [matTooltip]="
                          translationService.getIngredientIsSubstanceOfConcernText()
                        "
                        >warning</mat-icon
                      >
                    }
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="casNumbers">
                <th mat-header-cell *matHeaderCellDef>
                  {{ translationService.getCasNumbersText() }}
                </th>
                <td mat-cell *matCellDef="let ingredient">
                  {{ ingredient.casNumbers }}
                </td>
              </ng-container>
              <tr
                mat-header-row
                *matHeaderRowDef="mayContainDisplayedColumns"
                class="header-row"
              ></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: mayContainDisplayedColumns"
              ></tr>
            </table>
          }

          @if (
            !product.productIngredients.length &&
            !product.mayContain.length &&
            !product.doesNotContain.length
          ) {
            <p>{{ translationService.getNoIngredientsDisclosedText() }}</p>
          }
        </div>
      </div>
    </div>
  } @else {
    <div class="mobile-view">
      <mat-toolbar class="row product-name-navbar">
        <span class="bold-600 medium-font">{{ product.name }}</span>
      </mat-toolbar>
      <div class="info-container-mobile">
        <div class="row margin-top-20">
          <span class="bold x-large-font">{{
            translationService.getIngredientsText()
          }}</span>
        </div>
        <div class="margin-top-20">
          <mat-divider></mat-divider>
        </div>

        @for (
          productIngredient of product.productIngredients;
          track productIngredient
        ) {
          <div class="row margin-top-10">
            <div class="icon-text">
              <span class="bold">{{ productIngredient.name }}</span>
              @if (productIngredient.optionallyDisclosed) {
                <mat-icon
                  [matTooltip]="translationService.getOptionalDisclosureText()"
                  >info</mat-icon
                >
              }
              @if (productIngredient.isSubstanceOfConcern) {
                <mat-icon
                  [matTooltip]="
                    translationService.getIngredientIsSubstanceOfConcernText()
                  "
                  >warning</mat-icon
                >
              }
            </div>
          </div>
          <div class="row margin-top-10">
            <span class="grey-text"
              >{{ translationService.getCasText() }}:
              {{
                productIngredient.casNumbers || translationService.getNaText()
              }}</span
            >
          </div>
          <div class="row margin-top-10">
            <span>
              {{ productIngredient.lowerConcentration }}% -
              {{ productIngredient.upperConcentration }}%</span
            >
          </div>
          <div class="margin-top-20">
            <mat-divider></mat-divider>
          </div>
        }

        @if (product.mayContain.length) {
          <div class="row margin-top-20">
            <span class="bold large-font">{{
              translationService.getMayContainText()
            }}</span>
          </div>
          <div class="margin-top-20">
            <mat-divider></mat-divider>
          </div>
          @for (
            productIngredient of product.mayContain;
            track productIngredient
          ) {
            <div class="row margin-top-10">
              <div class="icon-text">
                <span class="bold">{{ productIngredient.name }}</span>
                @if (productIngredient.optionallyDisclosed) {
                  <mat-icon
                    [matTooltip]="
                      translationService.getOptionalDisclosureText()
                    "
                    >info</mat-icon
                  >
                }
                @if (productIngredient.isSubstanceOfConcern) {
                  <mat-icon
                    [matTooltip]="
                      translationService.getIngredientIsSubstanceOfConcernText()
                    "
                    >warning</mat-icon
                  >
                }
              </div>
            </div>
            <div class="row margin-top-10">
              <span class="grey-text"
                >{{ translationService.getCasText() }}:
                {{
                  productIngredient.casNumbers || translationService.getNaText()
                }}</span
              >
            </div>
            <div class="margin-top-20">
              <mat-divider></mat-divider>
            </div>
          }
        }

        @if (product.doesNotContain.length) {
          <div class="row margin-top-20">
            <span class="bold large-font">{{
              translationService.getDoesNotContainText()
            }}</span>
          </div>
          <div class="margin-top-20">
            <mat-divider></mat-divider>
          </div>
          @for (
            productIngredient of product.doesNotContain;
            track productIngredient
          ) {
            <div class="row margin-top-10">
              <div class="icon-text">
                <span class="bold">{{ productIngredient.name }}</span>
                @if (productIngredient.optionallyDisclosed) {
                  <mat-icon
                    [matTooltip]="
                      translationService.getOptionalDisclosureText()
                    "
                    >info</mat-icon
                  >
                }
                @if (productIngredient.isSubstanceOfConcern) {
                  <mat-icon
                    [matTooltip]="
                      translationService.getIngredientIsSubstanceOfConcernText()
                    "
                    >warning</mat-icon
                  >
                }
              </div>
            </div>
            <div class="row margin-top-10">
              <span class="grey-text"
                >{{ translationService.getCasText() }}:
                {{
                  productIngredient.casNumbers || translationService.getNaText()
                }}</span
              >
            </div>
            <div class="margin-top-20">
              <mat-divider></mat-divider>
            </div>
          }
        }

        @if (
          !product.productIngredients.length &&
          !product.mayContain.length &&
          !product.doesNotContain.length
        ) {
          <p>{{ translationService.getNoIngredientsDisclosedText() }}</p>
        }

        <div class="row margin-top-20">
          <app-sustainability-highlights
            [productHighlights]="productHighlights"
            [isMobileView]="true"
          >
          </app-sustainability-highlights>
        </div>
      </div>
    </div>
  }
}
